import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actions, ApplicationStore } from "src/store";
import { authenticationMergeRequest } from "src/store/actions/deal";
import { isLockedPricingSetup } from "src/store/selectors/account";
import { getVehiclesArrayUntilRefactor } from "src/store/selectors/vehicles";
import UnlockGarage from "./state";

function mapStateToProps(state: ApplicationStore) {
    const { account, deal, onlineShopper } = state;
    return {
        accessRequest: deal.accessRequest,
        account,
        environment: onlineShopper.env,
        uuid: deal.uuid,
        vehicles: getVehiclesArrayUntilRefactor(state),
        isLockedPricing: isLockedPricingSetup(state),
        garageCreated: onlineShopper.garageCreated,
    };
}

const updateAccessRequest = actions.deal.updateAccessRequest;

const mapDispatchToProps = (dispatch: any) =>
    bindActionCreators(
        {
            updateAccessRequest,
            onSuccessfulAuthentication: authenticationMergeRequest,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(UnlockGarage);
